import React from "react";

import { AW23 } from "../../../../js/database/database-aw23-eshop.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const PUBeltedCombatPants = () => {
  return (
    <ProductsContainer
      pageTitle={AW23.pants.PUBeltedCombatPants.itemName}
      name={AW23.pants.PUBeltedCombatPants.itemName}
      price={AW23.pants.PUBeltedCombatPants.itemPrice}
      fabric={AW23.pants.PUBeltedCombatPants.itemFabric}
      src={AW23.pants.PUBeltedCombatPants.sizeChart}
      divId={AW23.pants.PUBeltedCombatPants.shopifyDivId}
      mainId={AW23.pants.PUBeltedCombatPants.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        AW23.pants.PUBeltedCombatPants.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={AW23.pants.PUBeltedCombatPants.itemName}
              width={AW23.imgWidth}
              height={AW23.imgHeight}
              loading={AW23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default PUBeltedCombatPants;
